import React, {Component} from 'react';
import {Tag,Button,message,Modal,Input} from 'antd';
import './style.css'
import Question from '../../../../entry_question_editor/question/question_view/view';
import Editor from '../../../../entry_question_editor/question/common/editor/';
import {getToolbars} from '../../../../utils/questionManageType';
import {getContentForExplainTask} from '../../../../utils/getEditorContent'
import axios from 'axios'
import { connect } from 'react-redux';
import API from '../../../../API/api'
import {getExplain} from '../../../../utils/createRender'
import UM from 'UM'
import  * as types from '@/utils/questionType'

const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);

const EXPLAIN_TASK_STAGE_MAP = {
    '0':'pre_assign',
    '10':'img_explain',
    '20':'pre_img_explain_check',
    '30':'img_explain_check',
    '32':'img_explain_rework',
    '100':'pre_text_explain',
    '110':'text_explain',
    '120':'pre_text_explain_check',
    '130':'text_explain_check',
    '132':'text_explain_rework',
    '200':'text_explain_pass',
    '1003':'text_explain_onlineing',
    '1001':'text_explain_online_success',
    '1002':'text_explain_online_fail',
}
class QuestionList extends Component {
    state = {
        selectQuestions: [],
        imgExplainEditing:false,
        textExplainEditing:false,
        reworkModal:false,
        mark:'',
        hiddenPic:true,
    }

    imgExplainSave=(val,question,current)=>{
        this.setState({imgExplainEditing:false})
        let explain = getContentForExplainTask([val])[0];
        const data = {
            task_id:window.location.href.split('/').pop(),
            question_id:question.question_id,
            content:explain,
        }
        let URL = API.QUESTION_PIC_ENTRY_SUBMIT
        if(current ==='img_explain_check'){URL = API.QUESTION_PIC_CHECK_MOD_SUBMIT}
        if(current ==='img_explain_rework'){URL = API.QUESTION_PIC_ENTRY_RESUBMIT}
        axios.post(URL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                question.explain_pic = explain
                // this.forceUpdate()
                if(current ==='img_explain_check'&&this.props.tab==='pic_check_no'){
                    this.forceUpdate()
                }else{
                    this.props.refresh()
                }
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})

    }
    imgExplainEdit=(v,editor)=>{
        this.setState({imgExplainEditing:true})
        UM.getEditor(editor).setContent(getExplain(v.explain_pic)||'')
    }
    picPass=(question)=>{
        const data = {
            task_id:window.location.href.split('/').pop(),
            question_id:question.question_id,
        }
        let URL = API.QUESTION_PIC_CHECK_PASS
        axios.post(URL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('保存成功')
                this.props.refresh()

            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //返工原因
    onChangeMark = (e) => {
        this.state.mark = e.target.value
    }
    picRework=(question)=>{
        if(this.state.mark===''){return message.error('请填写返工原因')}
        const data = {
            task_id:window.location.href.split('/').pop(),
            question_id:question.question_id,
            rework_mark:this.state.mark
        }
        this.setState({reworkModal: false})
        let URL = API.QUESTION_PIC_CHECK_REWORK
        axios.post(URL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('返工成功')
                this.props.refresh()

            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    //录解析相关
    textExplainSave=(val,question,current)=>{
        this.setState({textExplainEditing:false})
        let explain = getContentForExplainTask([val])[0];
        //子题解析
        let sub_explain=this.props.data.sub_list.map(v=>{
        		let explain_editor_id='explain_text'+v.question_id
        		return {
        			question_id:v.question_id,
        			content:getContentForExplainTask([explain_editor_id])[0]
        		}

        })
        const data = {
            task_id:window.location.href.split('/').pop(),
            question_id:question.question_id,
            content:explain,
            sub_content:sub_explain
        }
        let URL = API.QUESTION_TEXT_ENTRY_SUBMIT
        if(current ==='text_explain_check'){URL = API.QUESTION_TEXT_CHECK_MOD_SUBMIT}
        if(current ==='text_explain_rework'){URL = API.QUESTION_TEXT_ENTRY_RESUBMIT}
        if(current ==='text_explain_pass'){URL = API.QUESTION_TEXT_ENTRY_ADMINEDIT}

        axios.post(URL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                question.explain_text = explain
                // this.forceUpdate()
                if(current ==='text_explain_check'&&this.props.tab==='text_check_no'){
                    this.forceUpdate()
                }else{
                    this.props.refresh()
                }

            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})

    }
    textExplainEdit=(v,editor)=>{
        this.setState({textExplainEditing:true})
        UM.getEditor(editor).setContent(getExplain(v.explain_text)||'')
        //子题解析
        let {TYPE_SHOW_EN_READ,TYPE_SHOW_EN_READ_HEAR,TYPE_SHOW_CN_READ,TYPE_SHOW_FILLINBLANK}=types
        let hasSub=[TYPE_SHOW_EN_READ,TYPE_SHOW_EN_READ_HEAR,TYPE_SHOW_CN_READ,TYPE_SHOW_FILLINBLANK].includes(v.type_show)
        if(hasSub){
        		let {data}=this.props
        		data.sub_list.forEach(n=>{
        			UM.getEditor('explain_text'+n.question_id).setContent(getExplain(n.explain_text)||'')
        		})
        }
       
        	
        
    }
    textPass=(question)=>{
        const data = {
            task_id:window.location.href.split('/').pop(),
            question_id:question.question_id,
        }
        let URL = API.QUESTION_TEXT_CHECK_PASS
        axios.post(URL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('保存成功')
                this.props.refresh()

            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

    textRework=(question)=>{
        if(this.state.mark===''){return message.error('请填写返工原因')}
        const data = {
            task_id:window.location.href.split('/').pop(),
            question_id:question.question_id,
            rework_mark:this.state.mark
        }
        this.setState({reworkModal: false})
        let URL = API.QUESTION_TEXT_CHECK_REWORK
        axios.post(URL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('返工成功')
                this.props.refresh()

            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

    componentDidUpdate() {
        $('.viewer .mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
    }
    componentDidMount() {
        $('.viewer .mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
    }
    createHtml = str => ({__html: str ? str : `&nbsp;`});
    
    renderEditExplain(itemData){
    		const {role_qexplain,stage,k,pagesize=10,page} = this.props;
        let current = EXPLAIN_TASK_STAGE_MAP[stage]
		let {subject}=this.props,
			questionType=itemData.type_show,
			{TYPE_SHOW_EN_READ,TYPE_SHOW_EN_READ_HEAR,TYPE_SHOW_CN_READ,TYPE_SHOW_FILLINBLANK}=types

    		let judgeRead=["1","2"].includes(subject)&&[TYPE_SHOW_EN_READ,TYPE_SHOW_EN_READ_HEAR,TYPE_SHOW_CN_READ,TYPE_SHOW_FILLINBLANK].includes(questionType)
    		if(judgeRead){
    			return(
	    			<div className="question_explain_content">
	    			{
	    				itemData.sub_list.map((v,i)=>
	    					<div key={v.question_id}>
	    					<div>
                            <span style={{fontSize:'18px'}}>{(page-1)*pagesize+k+1}-{i+1}录解析</span>
                        </div>
                        <div style={this.state.textExplainEditing?{}:{display:'none'}}>
                            <Editor hideFullscreen={true} width={'100%'} id={'explain_text'+v.question_id} toolbar={getToolbars(this.props.subject,'stem')}/>
                        </div>

                        <div className={'viewer'} style={this.state.textExplainEditing?{display:'none'}:{border:'1px solid #00b1ff',padding:'10px',minHeight:'100px',wordBreak: 'break-all'}}>
                            <div style={{fontSize:'16px'}}dangerouslySetInnerHTML={this.createHtml(getExplain(v.explain_text||''))}/>
                        </div>
		                </div>
	    				)
	    			}
	    			</div>
	    		)
    		}
    		

    }

    render() {

        const {data = {},taskId = '',pagesize=10,role_qexplain,stage,k} = this.props;
        let current = EXPLAIN_TASK_STAGE_MAP[stage]
        if(!role_qexplain||stage===''){
            return null
        }
        data.id = data.question_id;
        data.rate = data.right_rate;
        let v = data;
        let page = this.props.page;
        if(!page){page = 1}
        return (
            <div>
                {
                    <div key={v.question_id} style={{marginBottom: '30px',position:'relative',overflow:'hidden'}}>
                        <div className={'question'} style={{float:'left',width:'55%'}}>

                            <Question data={v}  num={(page-1)*pagesize+k}  />

                        </div>
                        
                        {	
                            <div className={'question_explain_content'} style={{minHeight:'200px',width:'43%',float: 'left',marginLeft:'1%'}} ref={'viewer'}>
                                <div style={{fontSize:'14px'}}>
                                    {
                                    		this.props.subject=="0"&&
                                    		<div><Button type={this.state.hiddenPic?'primary':''} onClick={()=>{this.setState({hiddenPic:!this.state.hiddenPic})}}>{this.state.hiddenPic?'显示录解析':'隐藏录解析'}</Button></div>
                                    }
                                    
                                    {
                                        !((current==='pre_text_explain'||
                                            current==='text_explain'||
                                            current==='pre_text_explain_check'||
                                            current==='text_explain_check'||
                                            current==='text_explain_rework'||
                                            current==='text_explain_pass'||
                                            current==='text_explain_onlineing'||
                                            current==='text_explain_online_success'||
                                            current==='text_explain_online_fail'
                                        )&&this.state.hiddenPic)
                                        &&
                                        <div>
                                            <div>
                                                <span style={{fontSize:'18px'}}>编写解析</span>
                                            </div>


                                            <div style={this.state.imgExplainEditing?{}:{display:'none'}}>
                                                <Editor hideFullscreen={true} width={'100%'} id={'explain_img'+v.question_id} toolbar={getToolbars(this.props.subject,'stem')}/>
                                            </div>

                                            <div className={'viewer'} style={this.state.imgExplainEditing?{display:'none'}:{border:'1px solid #00b1ff',padding:'10px',minHeight:'100px',wordBreak: 'break-all'}}>
                                                <div style={{fontSize:'16px'}} dangerouslySetInnerHTML={this.createHtml(getExplain(v.explain_pic||''))}/>
                                            </div>
                                            
                                            
                                            {/*返工原因展示*/}
                                            { (current==='img_explain_check'||current==='img_explain_rework')&&
                                            v.rework_mark_pic &&v.rework_mark_pic!==''&&
                                            v.stage=='23'&&
                                            <div style={{textAlign:'center',fontSize:'15px',paddingBottom:'15px',borderBottom:'1px solid #eee'}}>
                                                <Tag color="#f50" style={{fontSize:14}}><span>返工原因：</span><span>{v.rework_mark_pic}</span></Tag>
                                            </div>
                                            }

                                            <div style={ this.state.imgExplainEditing?{textAlign:'right',margin:'10px 0',display:'none'}:{textAlign:'right',margin:'10px 0'}}>
                                                {
                                                    role_qexplain.buttons.picCheck==1&&
                                                    (
                                                        current==='img_explain_check')&&
                                                    <span>
                                                           {
                                                               v.stage!=='21'&&v.stage!=='22'&&//通过的状态不显示通过按钮
                                                               <Button type="primary" style={{marginLeft:'10px'}} onClick={()=>{this.picPass(v)}}>通过</Button>
                                                           }
                                                        {
                                                            v.stage!=='23'&&
                                                            <Button style={{marginLeft:'10px'}} onClick={() => this.setState({reworkModal: true})}>返工</Button>
                                                        }

                                                        <Modal title="返工原因" visible={this.state.reworkModal} onOk={()=>{this.picRework(v)}}
                                                               onCancel={() => this.setState({reworkModal: false})}>
                                                                <Input style={{margin: '10px 0'}} onChange={this.onChangeMark}/>
                                                            </Modal>
                                                        </span>
                                                }

                                                {
                                                    (role_qexplain.buttons.picCheck==1||role_qexplain.buttons.picEntry==1)&&
                                                    (current==='img_explain'||
                                                        current==='img_explain_check'||
                                                        (current==='img_explain_rework'&&(v.stage=='23'||v.stage=='11'))
                                                    )&&
                                                    //题目是已完成情况不能编辑
                                                    <span>
                                                       {
                                                           <Button style={{marginLeft:'10px'}} onClick={()=>{this.imgExplainEdit(v,'explain_img'+v.question_id)}}>编辑</Button>
                                                       }
                                                    </span>
                                                }
                                            </div>
                                            <div style={ this.state.imgExplainEditing?{textAlign:'right',margin:'10px 0'}:{textAlign:'right',margin:'10px 0',display:'none'}}>
                                                <Button type="primary" style={{marginLeft:'10px'}} onClick={()=>{this.imgExplainSave('explain_img'+v.question_id,v,current)}}>保存</Button>
                                                <Button style={{marginLeft:'10px'}} onClick={()=>{this.setState({imgExplainEditing:false})}}>取消</Button>
                                            </div>
                                        </div>
                                    }
                                    {(current==='pre_text_explain'||
                                        current==='text_explain'||
                                        current==='pre_text_explain_check'||
                                        current==='text_explain_check'||
                                        current==='text_explain_rework'||
                                        current==='text_explain_pass'||
                                        current==='text_explain_onlineing'||
                                        current==='text_explain_online_success'||
                                        current==='text_explain_online_fail'
                                    )&&
                                    <div>
                                        <div>
                                            <span style={{fontSize:'18px'}}>录解析</span>
                                        </div>


                                        <div style={this.state.textExplainEditing?{}:{display:'none'}}>
                                            <Editor hideFullscreen={true} width={'100%'} id={'explain_text'+v.question_id} toolbar={getToolbars(this.props.subject,'stem')}/>
                                        </div>

                                        <div className={'viewer'} style={this.state.textExplainEditing?{display:'none'}:{border:'1px solid #00b1ff',padding:'10px',minHeight:'100px',wordBreak: 'break-all'}}>
                                            <div style={{fontSize:'16px'}}dangerouslySetInnerHTML={this.createHtml(getExplain(v.explain_text||''))}/>
                                        </div>
                                        
                                        {this.renderEditExplain(v)}
                                        {/*返工原因展示*/}

                                        {   (current==='text_explain_check'||current==='text_explain_rework')&&
                                        v.rework_mark_text &&v.rework_mark_text!==''&&
                                        v.stage=='43'&&
                                        <div style={{textAlign:'center',fontSize:'15px',paddingBottom:'15px',borderBottom:'1px solid #eee'}}>
                                            <Tag color="#f50" style={{fontSize:14}}><span>返工原因：</span><span>{v.rework_mark_text}</span></Tag>
                                        </div>
                                        }

                                        <div style={ this.state.textExplainEditing?{textAlign:'right',margin:'10px 0',display:'none'}:{textAlign:'right',margin:'10px 0'}}>

                                            {
                                                role_qexplain.buttons.textCheck==1&&
                                                (
                                                    current==='text_explain_check')&&
                                                <span>
                                                               {
                                                                   v.stage!=='41'&&v.stage!=='42'&&//通过的状态不显示通过按钮
                                                                   <Button type="primary" style={{marginLeft:'10px'}} onClick={()=>{this.textPass(v)}}>通过</Button>
                                                               }
                                                    {
                                                        v.stage!=='43'&&//返工的的状态不显示返工按钮
                                                        <Button style={{marginLeft:'10px'}} onClick={() => this.setState({reworkModal: true})}>返工</Button>
                                                    }

                                                    <Modal title="返工原因" visible={this.state.reworkModal} onOk={()=>{this.textRework(v)}}
                                                           onCancel={() => this.setState({reworkModal: false})}>
                                                                <Input style={{margin: '10px 0'}} onChange={this.onChangeMark}/>
                                                            </Modal>
                                                        </span>
                                            }

                                            {
                                                (role_qexplain.buttons.textCheck==1||role_qexplain.buttons.textEntry==1)&&
                                                (current==='text_explain'||
                                                    current==='text_explain_check'||
                                                    (current==='text_explain_rework'&&(v.stage=='43'||v.stage=='31'))
                                                )&&
                                                //题目是已完成情况不能编辑
                                                <span>
                                                                <Button style={{marginLeft:'10px'}} onClick={()=>{this.textExplainEdit(v,'explain_text'+v.question_id)}}>编辑</Button>
                                                            </span>
                                            }
                                            {
                                                role_qexplain.buttons.textAdminEdit==1&&
                                                current==='text_explain_pass'&&
                                                //超级管理员在完成阶段也可以修改题目
                                                <span>
                                                                <Button style={{marginLeft:'10px'}} onClick={()=>{this.textExplainEdit(v,'explain_text'+v.question_id)}}>编辑</Button>
                                                            </span>
                                            }

                                        </div>
                                        <div style={ this.state.textExplainEditing?{textAlign:'right',margin:'10px 0'}:{textAlign:'right',margin:'10px 0',display:'none'}}>
                                            {
                                                <Button type="primary" style={{marginLeft:'10px'}} onClick={()=>{this.textExplainSave('explain_text'+v.question_id,v,current)}}>保存</Button>
                                            }
                                            <Button style={{marginLeft:'10px'}} onClick={()=>{this.setState({textExplainEditing:false})}}>取消</Button>
                                        </div>
                                    </div>
                                    }

                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        )
    }
}


const mapStateTopProps = (state) => {

    return {
        subject: state.user.subject,
    };
}
const mapDispatchToProps = dispatch => {
    return {}
    
};

export default connect(mapStateTopProps,mapDispatchToProps)(QuestionList);




// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_explain/explain_detail_question/view.js